import script from "./PreprProductDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PreprProductDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__